<template>
  <b-modal
    id="modalAddTransectionGatewayInSale"
    centered
    title="Insert transaction and gateway"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <div class="mb-3">
      <label for="id_sale" class="form-label">ID da venda</label>
      <b-form-input
        id="id"
        v-model="id_sale"
        placeholder="Digite o ID"
        type="number"
        :state="!errorsForm.id_sale"
      />
      <b-form-invalid-feedback v-if="errorsForm.id_sale">
        {{ errorsForm.id_sale }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="transaction_id" class="form-label">ID da transação</label>
      <b-form-input
        id="transaction_id"
        v-model="transaction_id"
        placeholder="Digite o ID da transação"
        type="text"
        :state="!errorsForm.transaction_id"
      />
      <b-form-invalid-feedback v-if="errorsForm.transaction_id">
        {{ errorsForm.transaction_id }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="gateway" class="form-label">Gateway</label>
      <b-form-input
        id="gateway"
        v-model="gateway"
        placeholder="Ex: WORLDPAY"
        type="text"
        :state="!errorsForm.gateway"
      />
      <b-form-invalid-feedback v-if="errorsForm.gateway">
        {{ errorsForm.gateway }}
      </b-form-invalid-feedback>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="success" @click="submitData">Adicionar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import transactionGateway from '@services/resources/transactionGatewayService';

const serviceTransactionGateway = transactionGateway.build();

export default {
  name: 'modalRemoveUserSettings',
  data() {
    return {
      id_sale: '',
      transaction_id: '',
      gateway:'',
      errorsForm: {},
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      if (!this.id_sale.toString().trim()) {
        this.errorsForm.id_sale = 'O campo ID da venda é obrigatório.';
      }

      if (!this.transaction_id.toString().trim()) {
        this.errorsForm.transaction_id = 'O campo ID da transação';
      }

      if (!this.gateway.toString().trim()) {
        this.errorsForm.gateway = 'O campo Gateway é obrigatório.';
      }

      return Object.keys(this.errorsForm).length === 0;
    },

    async submitData() {
      if (!this.validateFields()) return;

      try {

        await serviceTransactionGateway.post('',{
          gateway:this.gateway,
          transaction_id: this.transaction_id,
          sale_id: this.id_sale,
        } );

        this.$bvToast.toast('Tansação e gateway adicionada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalRemoveUserSettings');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao enviar';

        if (
          error.response &&
          error.response.status === 422 &&
          typeof error.response.data === 'string'
        ) {
          const parsed = JSON.parse(error.response.data);

          if (parsed.errors) {
            message = Object.values(parsed.errors)
              .flat()
              .join('\n');
          }

        } else if (
          error.response &&
          typeof error.response.data === 'object' &&
          error.response.data.errors
        ) {
          
          if (parsedData.errors.hasOwnProperty(key)) {
            message = message.concat(parsedData.errors[key]);
          }

          message = error.response.data.errors[firstKey][0];

        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },

    resetForm() {
      this.id_sale = '';
      this.transaction_id = '';
      this.gateway = ''
      this.errorsForm = {};
    },
  },
};
</script>
